// extracted by mini-css-extract-plugin
module.exports = {"container":"ReferFriend__container--jSX","title":"ReferFriend__title--2Z3","message":"ReferFriend__message--2EO","error":"ReferFriend__error--2We","box":"ReferFriend__box--3dP"};